import{Formik, Form, Field,ErrorMessage, useFormikContext, FormikValues} from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';
import ComboBox from '../../Certificados/ComboBox';
import { Guardaruser } from '../../../interfaces/UsuariosRoles';
import SelectMultiple from '../../Certificados/SelectMultiple';
import AlertService from '../../../services/AlertService';
import Alert from '@mui/material/Alert';
import { CasUserContext } from '../../../services/casUserContext';
import { useNavigate } from 'react-router-dom';
import { Button, Input, Paper } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Producto_Esperado, objProductoEsperado } from '../../../interfaces/Sistema';
import ProductoService from '../../../services/ProductoService';

const alertService = new AlertService();
const productoService = new ProductoService();


interface opcion{
    value:string,
    label: string,
}

interface propsProducto{
    //categoria: GuardarCategoria,
    categorias : Array<opcion>,
    productoEsperado: objProductoEsperado
}

export default function IngresoProductoEsperado(props: propsProducto){
    const opciones = [
        { value: '1', label: 'SI' },
        { value: '0', label: 'NO' },
      ];
    const casUserContext = useContext(CasUserContext);
    const token = casUserContext.token;
    const vacio:opcion = {value:'', label:''} 
    let decisionInicial: opcion = obtenerDecision(parseInt(props.productoEsperado.producto.activo),vacio);
    const [selectedDecision, setSelectedDecision] = useState<opcion>(decisionInicial);

    let categoriaInicial: opcion = obtenerCategoria(parseInt(props.productoEsperado.producto.categoria),vacio)
    const [selectedCategoria, setSelectedCategoria] = useState<opcion>(categoriaInicial);

    const handleComboBoxChangeDecision = (selectedDecision: opcion) => {
        //console.log(selectedDecision);
        setSelectedDecision(selectedDecision);
    };

    const handleComboBoxChangeCategoria = (selectedCategoria: opcion) => {
        setSelectedCategoria(selectedCategoria);
    };


    function obtenerDecision(id: number, porDefecto: opcion):opcion{
        const decision = opciones.find((op)=> parseInt(op.value)===id);
        return decision || porDefecto
    }

    function obtenerCategoria(id: number, porDefecto: opcion):opcion{
        const categoria = props.categorias.find((op)=> parseInt(op.value)===id);
        return categoria || porDefecto
    }


    

    const Save = async (values:any, actions: any) =>{
        if(selectedCategoria.value===''){
            alertService.alertaAdvertencia('Error','Por favor escoger una categoría')
            return
        }
        if(selectedDecision.value===''){
            alertService.alertaAdvertencia('Error','Por favor escoger una opción en el campo Activo')
            return
        }


        let producto_esperado: Producto_Esperado={
            producto: values.tipoProducto,
            categoria: selectedCategoria.value,
            activo: selectedDecision.value
        }

        let idProducto = 0;

        let saveProductoEsperado:objProductoEsperado={
            producto: producto_esperado,
            idprodesp: idProducto
        }

        if(props.productoEsperado.idprodesp===0){
            alertService.showLoading("Guardando nuevo producto esperado...");
            //console.log("guardar",saveProductoEsperado);
            const resp = await productoService.GuardarProductoEsperado(saveProductoEsperado,token);
            alertService.hideLoading();
            if(resp.status.isSuccessfully) {
                alertService.alertaExito("Exito","Nuevo tipo producto esperado guardado");
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
                
            }else{
                alertService.alertaAdvertenciaList("Error",resp.status.messages);
            }

        }else{
            saveProductoEsperado.idprodesp = props.productoEsperado.idprodesp;
            alertService.showLoading("Actualizando tipo producto esperado...");
            //console.log("Actualizar",saveProductoEsperado);
            const resp = await productoService.ActualizarProductoEsperado(token,saveProductoEsperado);
            alertService.hideLoading();
            if(resp.status.isSuccessfully) {
                alertService.alertaExito("Exito","Tipo producto esperado actualizado");
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            }else{
                alertService.alertaAdvertenciaList("Error",resp.status.messages);
            }
        }
    }

    const validationSchema = Yup.object({
        tipoProducto: Yup.string().required('El campo Tipo es obligatorio')
        
    });

    return(
       
        <Formik

        initialValues={{tipoProducto:props.productoEsperado.producto.producto}}
        validationSchema={validationSchema}
        onSubmit={Save}
        >

        {({ values, handleChange, handleBlur, handleSubmit, setFieldValue })=>(
            <Form>
                <Grid style={{padding:'15px'}} container spacing={2}>
                    <Grid item xs={3} md={3}>
                        <label><strong>Tipo: </strong></label>
                    </Grid>
                    <Grid item xs={9} md={9}>
                        <Field style={{width:'100%'}} type="text" id="tipoProducto" name="tipoProducto" />
                        <ErrorMessage name="tipoProducto">
                            {(error) => (
                                <Alert severity="error">
                                {error}
                                </Alert>
                            )}
                        </ErrorMessage>
                    </Grid>
                </Grid>
                <Grid style={{padding:'15px'}} container spacing={2}>
                    <Grid item xs={3} md={3}>
                        <label><strong>Categoría: </strong></label>
                        </Grid>
                    <Grid item xs={9} md={9}>
                        <Field component={ComboBox} options={props.categorias} onChange={handleComboBoxChangeCategoria} placeHolder='Seleccione una categoría' name='categoria' porDefecto={selectedCategoria.value!='' ? selectedCategoria : null} ></Field>
                    </Grid>
                </Grid>

                <Grid style={{padding:'15px'}} container spacing={2}>
                    <Grid item xs={3} md={3}>
                        <label htmlFor='activo'><strong>Activo: </strong></label>
                    </Grid>
                    <Grid item xs={9} md={9}>
                        <Field component={ComboBox} options={opciones} onChange={handleComboBoxChangeDecision} placeHolder='Seleccione una opción' name='activo' porDefecto={selectedDecision.value!='' ? selectedDecision : null} ></Field>
                    </Grid>
                </Grid>

                <Grid style={{margin:'5px', padding:'15px'}} container spacing={2}>
                    <Button type="submit" variant="contained"> Guardar</Button>
                </Grid>
            </Form>
        )}

        </Formik>

        
        
        
        
    )

    
}
